import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import AdminLayout from "@/pages/admin/AdminLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

const EDITABLE = [
  ["ricepoints_per_kg", "RicePoints per kg (₹)", "number"],
  ["redemption_cap_pct", "Redemption cap (%)", "number"],
  ["min_order_value", "Minimum order value (₹)", "number"],
  ["max_tradein_kg", "Max trade-in quantity (kg)", "number"],
  ["points_expiry_enabled", "Point expiration enabled", "bool"],
];

export default function AdminSettings() {
  const [settings, setSettings] = useState(null);

  useEffect(() => { api.get("/admin/settings").then(({ data }) => setSettings(data)); }, []);

  const save = async (key, value) => {
    const { data } = await api.put("/admin/settings", { key, value });
    setSettings(data);
    toast.success("Setting updated");
  };

  if (!settings) return <AdminLayout title="Settings"><div className="text-muted-foreground">Loading…</div></AdminLayout>;

  return (
    <AdminLayout title="Business Settings">
      <div className="max-w-xl bg-card border border-border rounded-lg p-6 space-y-5">
        <p className="text-sm text-muted-foreground">Business rules are configurable — not hard-coded. Changes apply immediately to the RicePoints engine.</p>
        {EDITABLE.map(([key, label, type]) => (
          <div key={key} className="flex items-center justify-between gap-4">
            <Label>{label}</Label>
            {type === "bool" ? (
              <Switch checked={!!settings[key]} onCheckedChange={(v) => save(key, v)} data-testid={`setting-${key}`} />
            ) : (
              <div className="flex gap-2">
                <Input type="number" defaultValue={settings[key]} className="w-32 h-9" data-testid={`setting-${key}`}
                       onBlur={(e) => Number(e.target.value) !== settings[key] && save(key, Number(e.target.value))} />
              </div>
            )}
          </div>
        ))}
        <div className="text-xs text-muted-foreground bg-muted rounded-md p-3">
          Point expiration is OFF by default. Do not enable hidden expiration without legal/accounting approval. Collected household rice must be segregated and handled per applicable Indian food-safety rules before any resale.
        </div>
      </div>
    </AdminLayout>
  );
}
